import { createFileRoute } from '@tanstack/react-router'
import { AppShell } from '../../components/AppShell'
import { TiketPage } from '../../components/TiketPage'
import { useLogout, useSession } from '../../hooks/useApi'

export const Route = createFileRoute('/platform/tiket')({
  component: TiketRoute,
  validateSearch: (search: Record<string, unknown>): { tiket?: string; mode?: string; page?: number } => ({
    tiket: typeof search.tiket === 'string' ? search.tiket : undefined,
    mode: typeof search.mode === 'string' ? search.mode : undefined,
    page:
      typeof search.page === 'number'
        ? search.page
        : typeof search.page === 'string'
          ? Number(search.page) || 1
          : undefined,
  }),
})

function TiketRoute() {
  const { data: session } = useSession()
  const logout = useLogout()
  const user = session?.user
  const { tiket, mode, page } = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <AppShell
      mode="global"
      userName={user?.name ?? 'Admin'}
      userEmail={user?.email ?? ''}
      onLogout={() => logout.mutate()}
      userRole={user?.role}
      userIsQc={(user as any)?.is_qc}
    >
      <TiketPage
        selectedId={tiket ?? null}
        creating={mode === 'create'}
        page={page ?? 1}
        onPageChange={(p) => navigate({ search: (prev) => ({ ...prev, page: p > 1 ? p : undefined }) })}
        onSelect={(id) => navigate({ search: (prev) => ({ ...prev, tiket: id }) })}
        onBack={() => navigate({ search: (prev) => ({ page: prev.page }) })}
        onCreateOpen={() => navigate({ search: (prev) => ({ ...prev, mode: 'create' }) })}
        onCreateClose={() => navigate({ search: (prev) => ({ page: prev.page }) })}
      />
    </AppShell>
  )
}
